import { Directive, ElementRef, inject, input, type OnChanges, type OnInit, Renderer2, type SimpleChanges } from '@angular/core';
import { InternalLinksService } from '@df/ui/common/internal-links.service';
import { TranslationService } from '@df/ui/translation/translation.service';

@Directive({
    selector: '[translateHtml]',
    standalone: true
})
export class TranslateHtmlDirective implements OnInit, OnChanges {
    translateHtml = input<string | undefined>();

    private initiated = false;
    private readonly elementRef = inject(ElementRef);
    private readonly renderer2 = inject(Renderer2);
    private readonly internalLinksService = inject(InternalLinksService);
    private readonly translationService = inject(TranslationService);

    ngOnInit() {
        this.initiated = true;
        this.apply();
    }

    ngOnChanges(changes: SimpleChanges) {
        this.apply();
    }

    private apply() {
        if (this.initiated) {
            const el = this.elementRef.nativeElement;
            const html = this.translateHtml();

            if (html) {
                this.renderer2.setProperty(el, 'innerHTML', this.translationService.translate(html));
            }

            this.internalLinksService.bind(el);
        }
    }
}
